import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Checkbox } from '@atlaskit/checkbox';
import { Field } from '@atlaskit/form';
import LabelComponent from '../LabelComponent/LabelComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const CheckboxInput = _ref => {
  let {
    options,
    onChange,
    value,
    isDisabled,
    fieldName
  } = _ref;
  const handleChange = event => {
    onChange(event.target.checked);
  };
  return /*#__PURE__*/_jsx(Field, {
    name: fieldName,
    defaultValue: value === null || value === void 0 ? void 0 : value.toString(),
    children: _ref2 => {
      let {
        fieldProps
      } = _ref2;
      return options.map(_ref3 => {
        let {
          label
        } = _ref3;
        return /*#__PURE__*/_createElement(Checkbox, _objectSpread(_objectSpread({}, fieldProps), {}, {
          type: "radio",
          onChange: handleChange,
          label: /*#__PURE__*/_jsx(LabelComponent, {
            label: label
          }),
          key: label.text,
          isChecked: value,
          isDisabled: isDisabled,
          testId: fieldName,
          "aria-checked": value,
          role: "checkbox"
        }));
      });
    }
  });
};
export default CheckboxInput;